import React from "react";
import { Outlet } from "react-router-dom";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarHeader,
  SidebarMenu,
  SidebarProvider,
  SidebarRail,
} from "ui/components/sidebar";
import { NavItem } from "@/components/nav/item";
import { DASHBOARD, CONFIG } from "icons";
import { MilestoneProvider, useMilestone } from "@/modules/work/milestones/context";
import { ROUTE } from "@/lib/utils";
import { MilestoneHeader } from "./components/header";
import { CollapsibleMilestoneHeader } from "./components/collapsible-header";

const MilestoneLayoutContent = (props) => {
  const { milestoneId, milestone } = useMilestone();

  return (
    <div className="flex-1 relative min-w-0">
      <MilestoneHeader />
      <div className="flex flex-1 relative min-w-0">
        {/* <SidebarProvider
          className="w-fit overflow-hidden max-h-dvh"
          name="milestone"
        >
          <Sidebar
            collapsible="icon"
            {...props}
            className="sidebar-height border-r left-auto inset-y-auto top-0 mt-28"
          >
            <SidebarHeader className="p-0">
              <div className="p-4">
                <CollapsibleMilestoneHeader milestone={milestone} />
              </div>
            </SidebarHeader>
            <SidebarContent>
              <SidebarGroup>
                <SidebarMenu>
                  <NavItem
                    title="Dashboard"
                    icon={DASHBOARD}
                    url={ROUTE.MILESTONE(milestoneId)}
                    matchExact={true}
                  />
                  <NavItem
                    title="Edit"
                    icon={CONFIG}
                    url={ROUTE.MILESTONE_EDIT(milestoneId)}
                    requiredPermissions={{
                      type: "collection",
                      collection: "milestones",
                      action: "update",
                    }}
                  />
                </SidebarMenu>
              </SidebarGroup>
            </SidebarContent>
            <SidebarRail />
          </Sidebar>
        </SidebarProvider> */}

        <div className="flex-1 overflow-auto min-w-0">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

const MilestoneLayout = (props) => {
  return (
    <MilestoneProvider>
      <MilestoneLayoutContent {...props} />
    </MilestoneProvider>
  );
};

export default MilestoneLayout;
